// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "@fortawesome/fontawesome-free/css/all.min.css"; // Choose either all.css or all.min.css, not both
// // import "./index.css"; // Uncomment if needed
// import * as serviceWorker from "./serviceWorker";
// import App from "./app/App";
// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";
// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// import { msalConfig } from "./app/authConfig";

// // Import translations
// import translations_en from "./locales/en/translation.json";
// import translations_fr from "./locales/fr/translation.json";
// import translations_mr from "./locales/mr/translation.json";

// // Third-party styles
// import "perfect-scrollbar/css/perfect-scrollbar.css";
// import "chartjs-adapter-date-fns";

// import { initializeIcons } from "@fluentui/react";
// initializeIcons(); // Initialize Fluent UI icons only once

// // Create root element
// const root = createRoot(document.getElementById("root"));

// // i18n setup
// i18n.use(initReactI18next).init({
//   resources: {
//     en: { translation: translations_en },
//     fr: { translation: translations_fr },
//     mr: { translation: translations_mr }
//   },
//   lng: "en", // Default language
//   fallbackLng: "en",
//   interpolation: {
//     escapeValue: false
//   }
// });

// const msalInstance = new PublicClientApplication(msalConfig);

// root.render(
//   <BrowserRouter>
//     <MsalProvider instance={msalInstance}>
//       <App />
//     </MsalProvider>
//   </BrowserRouter>
// );

// // Unregister service worker (for production, consider serviceWorker.register())
// serviceWorker.unregister();


import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as serviceWorker from "./serviceWorker";
import App from "./app/App";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./app/authConfig";
import translations_en from "./locales/en/translation.json";
import translations_fr from "./locales/fr/translation.json";
import translations_mr from "./locales/mr/translation.json";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "chartjs-adapter-date-fns";
import { initializeIcons } from "@fluentui/react";

initializeIcons();

const root = createRoot(document.getElementById("root"));

// i18n setup
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translations_en },
    fr: { translation: translations_fr },
    mr: { translation: translations_mr }
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

// Load runtime config before bootstrapping the app

fetch("/config/config.json")
  .then((res) => {
    if (!res.ok) throw new Error("Failed to load config.json");
    return res.json();
  })
  .then((config) => {
    window.runtimeConfig = config;

    // Dynamically update msalConfig based on runtime config
    // if (config.REACT_APP_CLIENT_ID && config.REACT_APP_TENANT_ID && config.REACT_APP_REDIRECT_URI) {
    //   msalConfig.auth.clientId = config.REACT_APP_CLIENT_ID;
    //   msalConfig.auth.authority = `https://login.microsoftonline.com/${config.REACT_APP_TENANT_ID}`;
    //   msalConfig.auth.redirectUri = config.REACT_APP_REDIRECT_URI;
    // } else {
    //   throw new Error("Missing required config values in config.json");
    // }

 if (window.runtimeConfig.clientId && window.runtimeConfig.tenantId && window.runtimeConfig.REACT_APP_REDIRECT_URI) {
      msalConfig.auth.clientId = window.runtimeConfig.clientId;
      msalConfig.auth.authority = `https://login.microsoftonline.com/${window.runtimeConfig.tenantId}`;
      msalConfig.auth.redirectUri = window.runtimeConfig.REACT_APP_REDIRECT_URI;
    } else {
      throw new Error("Missing required config values in config.json");
    }






    const msalInstance = new PublicClientApplication(msalConfig);

    root.render(
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </BrowserRouter>
    );
  })
  .catch((error) => {
    console.error("❌ Failed to load runtime config:", error);
    // Optionally show an error message in UI
    root.render(<div style={{color: "red"}}>Failed to load configuration. Please contact support.</div>);
  });

serviceWorker.unregister();
